module.exports = __webpack_public_path__ + "img/perfil_cifotico-lordotico.d5435339.jpg";